import React from 'react'
import ConfiguratorContainer from './ConfiguratorContainer'

const Configurator = () => <ConfiguratorContainer data-test="component-configurator-index" />
export default Configurator
